/* WorkTriggerPlanTargetsReadonlyTabRenderer.js */

"use strict";
// const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
//const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class WorkTriggerTargetsReadonlyTabRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("worktrig-plan-targets-readonly-view-tab-gl");
        this._rootElem.component = this._model;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        this._model._workTriggerDetailsView._renderer._rootElem.classList.add("plan-target-view");
        if (this._rootElem.hasChildNodes()) {
            this._renderBackButton();
            this._model.gameEditor._titleCmpnt.setTitle("Targets");
            this._model.gameEditor.showViewAction("BackToDetails");
            return Promise.resolve();
        }

        return this._renderBackButton()
            .then(() => this._renderGrid())
            .then(() => {
                this._registerListeners();
                this._model.gameEditor._titleCmpnt.setTitle("Targets");
                this._model.gameEditor.showViewAction("BackToDetails");
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    get selectedRows() {
        return this._selectedTargetsGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _renderBackButton() {
        const model = this._model;

        const bcs = [
            {
                content: backButton,
                left: {
                    arrow: {
                        direction: "left"
                    }
                }
            }
        ];
        this._model.gameEditor.setBreadCrumbs(bcs);

        return Promise.resolve();

        function backButton() {
            const el = document.createElement("span");
            el.innerHTML = "Details";
            el.addEventListener("click", () => {
                // clear breadcrumbs link
                model.gameEditor._titleCmpnt.setTitle("Details");
                model.gameEditor.hideViewAction("BackToDetails");
                model.gameEditor.setBreadCrumbs([]);
                // change tab back to general
                model.workTriggerDetailsView.setEditorMode("general");
            });
            // prettier-ignore
            this.renderer = { //jshint ignore:line
                rootElement: el
            };
        }
    }

    async _renderGrid() {
        if (!this._mainContainer) {
            this._mainContainer = document.createElement("plan-targets-main-container");
            this._rootElem.appendChild(this._mainContainer);
        }

        if (!this._gridContainer) {
            this._gridContainer = document.createElement("grid-container");
            this._mainContainer.appendChild(this._gridContainer);
        }

        if (this._selectedTargetsGrid) {
            this._gridContainer.removeChild(this._selectedTargetsGrid.renderer.rootElement);
            this._selectedTargetsGrid.shutdown();
        }

        this._selectedTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.columnConfig,
            pagingFeed: this._model.pagingFeed,
            showHeader: true,
            gridKey: `${this.model._gridKey}_selected`,
            showLinesNumber: this._model._gameEditor.renderer._rootElem.querySelector("game-editor-view-actions-gl left-container"),
            useUserDataStorage: false
        });
        this._gridContainer.appendChild(this._selectedTargetsGrid.renderer.rootElement);
        return Promise.resolve();
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onShutdown() {
        this._model._workTriggerDetailsView._renderer._rootElem.classList.remove("plan-target-view");
        let shutdowns = [this._selectedTargetsGrid.shutdown()];
        return Promise.all(shutdowns)
            .then(() => {
                this._unregisterListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._gridContainer.remove();
                this._gridContainer = undefined;
                this._selectedTargetsGrid = undefined;
            })
            .catch((err) => {
                this.model.logger.warn({ error: err }, "WorkTriggerTargetsReadonlyTabRenderer.shutdown() error");
            });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = WorkTriggerTargetsReadonlyTabRenderer;
